import React from 'react'
import { Checkbox } from 'primereact/checkbox'

import './CustomCheckbox.css'
import * as colors from '../../assets/js/colors'

export default function CustomCheckbox({ children, onChange, checked, disabled = false }) {
  const styles = {
    label: {
      fontSize: '0.8rem',
      color: colors.azul,
      display: 'inline-block',
      marginLeft: 5,
    },
  }
  return (
    <React.Fragment>
      <Checkbox
        className="CustomCheckbox"
        disabled={disabled}
        onChange={e => onChange(e.checked)}
        checked={checked}
      />
      <span style={styles.label}>{children}</span>
    </React.Fragment>
  )
}
